<div class="title" i18n="@@universalbenefits_beneficios_de_hoteles_universal_orlando">
  Beneficios de Hoteles de Universal Orlando
</div>
<div class="list">
  @if (hasUniversalExpress) {
    <div
      [mb-tooltip]="pase_universal_express"
      mbTooltipColor="light"
      mbTooltipPosition="below"
    >
      <mb-icon-text>
        <mb-icon icon="ticket"></mb-icon>
        <span i18n="@@pase_universal_express">Pase Universal Express Unlimited^</span>
      </mb-icon-text>
      <ng-template #pase_universal_express i18n="@@pase_universal_express_detail"
        >Evita las filas normales en las atracciones más populares en Universal Studios
        Florida y Universal's Islands of Adventure. Llega a la diversión aún más rápido con
        un Pase Universal Express*. Válido para quienes se alojen en: Hard Rock Hotel®,
        Loews Royal Pacific Resort y Loews Portofino Bay Hotel.</ng-template
      >
    </div>
  }
  <div [mb-tooltip]="entrada_temprana" mbTooltipColor="light" mbTooltipPosition="below">
    <mb-icon-text>
      <mb-icon icon="clock"></mb-icon>
      <span i18n="@@entrada_temprana">Entrada Temprana*</span>
    </mb-icon-text>
    <ng-template #entrada_temprana i18n="@@entrada_temprana_detail"
      >Entrada Temprana al Parque para The Wizarding World of Harry Potter y Universal's
      Volcano Bay una hora antes de que el parque temático abra las puertas. Admisión al
      parque temático es requerida.</ng-template
    >
  </div>
  <div
    [mb-tooltip]="transporte_gratuito"
    mbTooltipColor="light"
    mbTooltipPosition="below"
  >
    <mb-icon-text>
      <mb-icon icon="transfer"></mb-icon>
      <span i18n="@@transporte_gratuito">Transporte gratuito</span>
    </mb-icon-text>
    <ng-template #transporte_gratuito i18n="@@transporte_gratuito_detail"
      >Transporte gratuito a los parques temáticos y a Universal CityWalk.</ng-template
    >
  </div>
  <div
    [mb-tooltip]="paga_con_la_llave_de_la_habitacion"
    mbTooltipColor="light"
    mbTooltipPosition="below"
  >
    <mb-icon-text>
      <mb-icon icon="bank-credit-card"></mb-icon>
      <span i18n="@@paga_con_la_llave_de_la_habitacion"
        >Paga con la llave de la habitación</span
      >
    </mb-icon-text>
    <ng-template
      #paga_con_la_llave_de_la_habitacion
      i18n="@@paga_con_la_llave_de_la_habitacion_detail"
      >Privilegios para pagar en todo el complejo con la llave de la
      habitación.</ng-template
    >
  </div>
  <div
    [mb-tooltip]="entrega_de_mercancia"
    mbTooltipColor="light"
    mbTooltipPosition="below"
  >
    <mb-icon-text>
      <mb-icon icon="packages"></mb-icon>
      <span i18n="@@entrega_de_mercancia">Entrega de mercancía</span>
    </mb-icon-text>
    <ng-template #entrega_de_mercancia i18n="@@entrega_de_mercancia_detail"
      >Entrega gratuita en el hotel de las compras hechas dentro del
      complejo.</ng-template
    >
  </div>
  <div class="details">
    <p (click)="toggleModal()" i18n="@@universalbenefits_ver_detalle_de_beneficios">
      Ver detalle de beneficios
    </p>
  </div>
</div>
